<template>
    <div
        :class="cssClasses"
        ref="sort-container"
        v-if="sortByFields.length !== 0">
        <div class="l-ss-c-sort-button-wrapper">
            <button
                class="l-ss-c-sort-button"
                @click="() => isDropdownActive = !isDropdownActive">
                {{ sortTitle }}
            </button>
            <div
                v-if="isDropdownActive"
                class="l-ss-c-sort-dropdown">
                <button
                    v-for="item in sortByFields"
                    :key="item.title"
                    class="l-ss-c-sort-dropdown-item"
                    @click="($event) => handleSort($event, item)">
                    {{ item.title }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import closest from '../helpers/closest';
    import getEventTarget from '../helpers/event-target';
    import { isObject } from 'lodash';

    export default {
        props: ['sortBy', 'sortDest', 'disableSortOptions'],
        data() {
            return {
                isDropdownActive: false,
            };
        },
        computed: {
            cssClasses() {
                return {
                    'l-ss-c-sort': true,
                };
            },
            sortByFields() {
                const sortFields = [
                    ...process.env.SEARCH_BOOSTER_QUERY_SORT_BY_FIELDS.split(','),
                    ...Object.keys(this.$configuration.additionalSort),
                ];
                return sortFields.reduce((memo, sortBy) => {
                    let locale = this.$t(`sort.fields.${sortBy}`);
                    let sortParam = null;
                    if (!isObject(locale)) {
                        locale = this.$configuration.additionalSort[sortBy];
                        sortParam = `param.${locale.param}`;
                    }
                    return [].concat(memo, Object.keys(locale).filter(el => el !== 'param').map((sortDest) => {
                        return {
                            title: locale[sortDest],
                            sortKey: sortBy,
                            sortBy: sortParam ? sortParam : sortBy,
                            sortDest,
                        };
                    }));
                }, []).filter(option => {
                    return !this.disableSortOptions?.includes(option.sortBy) && !this.disableSortOptions?.includes('all');
                });
            },
            activeSortField() {
                return this.sortByFields.find(item => item.sortBy === this.sortBy && item.sortDest === this.sortDest);
            },
            sortTitle() {
                return this.activeSortField
                    ? this.activeSortField.title
                    : this.$t('sort.empty-text');
            },
        },
        mounted() {
            const self = this;
            const onBodyClick = function (event) {
                const node = getEventTarget(event);
                if (!closest(node, '.l-ss-c-sort-button-wrapper')) {
                    self.isDropdownActive = false;
                }
            };
            this.onBodyClick = onBodyClick;
            document.body.addEventListener('click', this.onBodyClick);
        },
        beforeDestroy() {
            document.body.removeEventListener('click', this.onBodyClick);
        },
        methods: {
            handleSort(event, sort) {
                this.$emit('sort-change', sort);
                this.$emit('result-sort-click', { type: 'resultSort', event, selectSort: sort.title });
                this.isDropdownActive = false;
            },
        },
    };
</script>
